import { axiosCall } from "../../utils/axiosCall";
// import { getField, updateField } from 'vuex-map-fields'

// var today = new Date()
// var dateExpires = new Date()
// dateExpires.setDate(dateExpires.getDate() + 30)

function initialState() {
  return {
    status: "",
    invitations: [],
  };
}

const state = initialState;

const getters = {
  getInvitations: (state) => state.invitations,
  getInvitationsSent: (state) => {
    var statistics = state.invitationsStatistics;
    return statistics ? statistics.total : 0;
  },
  getInvitationsStatistics: (state) => {
    var statistics = state.invitationsStatistics;
    return statistics;
  },
  getInvitationsCompleted: (state) => {
    // var surveysCompleted = 0
    // for (var i in state.invitations) {
    //   if (state.invitations[i].status === 'complete') {
    //     surveysCompleted++
    //   }
    // }
    // const percentageCompleted = parseInt((surveysCompleted / state.invitations.length) * 100)
    // return percentageCompleted
    var statistics = state.invitationsStatistics;
    if (!statistics) {
      return 0;
    }
    const percentage = parseInt(
      (parseInt(statistics.statistics["complete"]) / statistics.total) * 100
    );
    return percentage;
  },
};

const actions = {
  INVITATIONS_GET: ({ commit, rootState }) => {
    // Cambiar esta parte por el de subir invitaciones real
    return new Promise((resolve, reject) => {
      commit("setSurveyStatus", "adding");
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      axiosCall({ url: "Invitations/get/" + snapshotId })
        .then((resp) => {
          console.log(resp.data);
          commit("setSurveyStatus", "success");
          commit("setInvitations", resp.data.invitations);
          resolve(resp);
        })
        .catch((err) => {
          commit("setSurveyStatus", "error");
          reject(err);
        });
    });
  },
  INVITATIONS_STATISTICS: ({ commit, rootState }) => {
    // Cambiar esta parte por el de subir invitaciones real
    return new Promise((resolve, reject) => {
      //  commit('setSurveyStatus', 'adding')
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      axiosCall({ url: "Invitations/getStatistics/" + snapshotId })
        .then((resp) => {
          //   commit('setSurveyStatus', 'success')
          commit("setInvitationsStatistics", resp.data.invitations);
          resolve(resp);
        })
        .catch((err) => {
          //   commit('setSurveyStatus', 'error')
          reject(err);
        });
    });
  },
  INVITATION_SAVE: ({ commit, rootState }, data) => {
    // Cambiar esta parte por el de subir invitaciones real
    return new Promise((resolve, reject) => {
      commit("setSurveyStatus", "adding");
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      axiosCall({ url: "Invitations/save/" + snapshotId, method: "POST", data })
        .then((resp) => {
          commit("setSurveyStatus", "success");
          resolve(resp);
        })
        .catch((err) => {
          commit("setSurveyStatus", "error");
          reject(err);
        });
    });
  },

  INVITATION_REMOVEIDS: ({ commit, dispatch, rootState }, data) => {
    console.log("INVITATION_REMOVEIDS");
    return new Promise((resolve, reject) => {
      commit("setSurveyStatus", "deleting");
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      axiosCall({
        url: "Invitations/removeids/" + snapshotId + "/" + data.templateId,
        method: "DELETE",
        data,
      })
        .then((resp) => {
          commit("setSurveyStatus", "success");
          dispatch("INVITATIONS_GET");
          resolve(resp);
        })
        .catch((err) => {
          commit("setSurveyStatus", "error");
          reject(err);
        });
    });
  },
  INVITATION_RENEW: ({ commit, dispatch, rootState }, data) => {
    console.log("INVITATION_RENEW");
    return new Promise((resolve, reject) => {
      commit("setSurveyStatus", "renewing");
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      axiosCall({
        url: "Invitations/renew/" + snapshotId + "/" + data.templateId,
        method: "PATCH",
        data: data,
      })
        .then((resp) => {
          commit("setSurveyStatus", "success");
          dispatch("INVITATIONS_GET");
          resolve(resp);
        })
        .catch((err) => {
          commit("setSurveyStatus", "error");
          reject(err);
        });
    });
  },
  INVITATION_RESEND: ({ commit, rootState }, data) => {
    console.log("INVITATION_RESEND");
    return new Promise((resolve, reject) => {
      commit("setSurveyStatus", "resending");
      const snapshotId = rootState.business.currentSnapshot.snapshotId;
      axiosCall({
        url: "Invitations/resend/" + snapshotId + "/" + data.templateId,
        method: "POST",
        data: data,
      })
        .then((resp) => {
          commit("setSurveyStatus", "success");
          console.log(resp);
          resolve(resp);
        })
        .catch((err) => {
          commit("setSurveyStatus", "error");
          console.log(err);
          reject(err);
        });
    });
  },
};

const mutations = {
  setSurveyStatus: (state, status) => {
    state.status = status;
  },
  setInvitations: (state, invitations) => {
    state.invitations = invitations;
  },
  setInvitationsStatistics: (state, invitations) => {
    state.invitationsStatistics = invitations;
  },
  addInvitation: (state, invitation) => {
    state.invitations.push(invitation);
  },
  deleteInvitation: (state, invitation) => {
    console.log("deleteInvitation mutation");
    state.invitations.splice(invitation.index, 1);
  },
  updateInvitation: (state, invitation) => {
    console.log("updateInvitation mutation");
    state.invitations[invitation.index] = invitation.item;
  },
  invitationsReset: (state) => {
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

/* function validateEmail (email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
} */

/* function formatDate (date) {
  var dd = date.getDate()
  var mm = date.getMonth() + 1 // January is 0!
  var yyyy = date.getFullYear()
  if (dd < 10) {
    dd = '0' + dd
  }

  if (mm < 10) {
    mm = '0' + mm
  }

  return mm + '/' + dd + '/' + yyyy
}*/
